import { createAsyncThunk } from "@reduxjs/toolkit";
// import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
// import { setSkill } from "./FlnActivitySlice";

// export const getTeacherBaselineThunk = async (body) => {
//   let response = await api.post("getMasterStudActSkills/", body);
//   return response.data;
// };
// export const getTeacherBaselineThunk = createAsyncThunk(
//   "teacherexam/get",
//   async (data, dispatch) => {
//     let response = await api.get(
//       `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.program}/${data.clas}/${data.subject}`
//     );
//     // dispatch(setSkill(response));
//     // return response.data;
//   }
// );
// export const getSkills = createAsyncThunk(
//   "getSkills/get",
//   async (data, { dispatch }) => {
//     let response = await api.get(
//       `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.program}/${data.clas}/${data.subject}`
//     );
//     dispatch(setSkill(response.data));
//     return response.data;
//   }
// );

// <-----------------------------------TopicAPI--------------------------------------->
export const getFlnTopics = async (params) => {
  const { topicId } = params;
  let response = await api.get("getMasterStudActContents" + "/" + topicId);
  console.log(response, "res");
  return response.data;
};

// <-----------------------------------SkillAPI--------------------------------------->

export const getAllContents = async (params) => {
  const { topicId } = params;
  let response = await api.get("getMasterStudActContents" + "/" + topicId);
  
  // Create a pseudo-response object to maintain compatibility with callers expecting res.status
  let result = { status: response.status, data: response.data };
  
  if (result.data && Array.isArray(result.data)) {
    result.data = result.data.map(item => {
      if (item.value) {
        if (typeof item.value === 'string' && item.value.includes('http')) {
          item.value = item.value.substring(item.value.indexOf('http'));
        } else if (Array.isArray(item.value)) {
          item.value = item.value.map(val => (typeof val === 'string' && val.includes('http') ? val.substring(val.indexOf('http')) : val));
        }
      }
      if (item.thumbnail && typeof item.thumbnail === 'string' && item.thumbnail.includes('http')) {
        item.thumbnail = item.thumbnail.substring(item.thumbnail.indexOf('http'));
      }
      return item;
    });
  }
  return result;
};

export const getAllSkillQuiz = async (params) => {
  const { topicId } = params;
  let response = await api.get("getMasterStudActQuiz" + "/" + topicId);
  return response.data;
};

export const saveFlnSkillQuiz = createAsyncThunk(
  "FlnSkillQuiz/Save",
  async (body) => {
    console.log("saveFlnSkillQuiz------->", body);
    let response = await api.post("saveMasterStudActQuiz", body);
    return response.data;
  }
);

export const updateFlnSkillQuiz = createAsyncThunk(
  "FlnSkillQuiz/update",
  async (body) => {
    console.log("saveFlnSkillQuiz------->", body);
    let response = await api.put("updateMasterStudActQuiz", body);
    return response.data;
  }
);

export const deleteFlnSkillQuiz = createAsyncThunk(
  "FlnSkillQuiz/delete",
  async (body) => {
    console.log("delete", body);
    let response = await api.put("deleteMasterStudActQuiz", body);
    return response.data;
  }
);
